import { render, staticRenderFns } from "./TheoryManage.vue?vue&type=template&id=ec7c56ea&scoped=true&"
import script from "./TheoryManage.vue?vue&type=script&lang=js&"
export * from "./TheoryManage.vue?vue&type=script&lang=js&"
import style0 from "./TheoryManage.vue?vue&type=style&index=0&id=ec7c56ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7c56ea",
  null
  
)

export default component.exports